module.exports = __webpack_public_path__ + "img/bizaccess.301af678.svg";